module.exports = __webpack_public_path__ + "static/media/Muli-Light.e36c1054.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli-Light.woff
// module id = 1291
// module chunks = 1